import { Image } from '@chakra-ui/react';
import YaxleLogo from '../assets/yaxleLogoBlue.png';

interface ResetToPartBaySelectionsIconProps {
    size?: number;
    /** Kept so existing call sites compile. The Yaxle mark is already brand blue. */
    color?: string;
}

/**
 * Yaxle mark used to bulk-revert part selections back to the options
 * originally selected for the shop.
 */
const ResetToPartBaySelectionsIcon = ({ size = 16 }: ResetToPartBaySelectionsIconProps) => (
    <Image
        src={YaxleLogo}
        alt=""
        boxSize={`${size}px`}
        minW={`${size}px`}
        objectFit="contain"
    />
);

export default ResetToPartBaySelectionsIcon;
